import React from "react";
import PropTypes from 'prop-types';
import StyleableSection from "../../../components/StyleableSection";
import {FormattedMessage} from "react-intl";
import CardAmountField from "./CardAmountField";
import CurrencyFormatter from "currency-formatter";
import {Typography, withStyles} from "@material-ui/core";

const styles = (theme) => ({
  section: {
    width: '100%',
  },
  fixedAmountContainer: {
    width: '100%'
  },
  amountHeader: {
    padding: 0
  },
  fixedAmount: {
    fontSize: 20
  },
});

AmountSection.propTypes = {
  amount: PropTypes.number.isRequired,
  cardDesign: PropTypes.object.isRequired,
  currency: PropTypes.object.isRequired,
  section: PropTypes.object.isRequired,
  presetBalances: PropTypes.array,
  customAmountAllowed: PropTypes.bool.isRequired,
  locale: PropTypes.string.isRequired,
  errors: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  classes: PropTypes.object
};

function AmountSection({
                         amount,
                         cardDesign,
                         currency,
                         section,
                         presetBalances,
                         customAmountAllowed = true,
                         locale,
                         errors,
                         classes,
                         onChange
                       }) {

  locale = locale.replace('-', '_');

  const isFixedAmountCardDesign = cardDesign.fixedAmount && cardDesign.fixedAmount > 0;
  let formattedFixedAmount = null;
  if (isFixedAmountCardDesign) {
    const adjustedFixedAmount = cardDesign.fixedAmount / Math.pow(10, currency.decimalDigits);
    formattedFixedAmount = CurrencyFormatter.format(adjustedFixedAmount, {
      locale,
      code: currency.code,
      precision: 2,
      format: '%s%v'
    });

  }

  if (isFixedAmountCardDesign) {
    return (
      <StyleableSection section={section}>
        <div className={classes.fixedAmountContainer}>
          <Typography variant={'subtitle1'} className={classes.amountHeader}><FormattedMessage id={"form.amount"}/></Typography>
          <Typography variant={"subtitle2"} className={classes.fixedAmount}>
            {formattedFixedAmount}
          </Typography>
        </div>
      </StyleableSection>
    );
  }

  return (
    <StyleableSection className={classes.section} section={section}>
      <CardAmountField
        amount={amount}
        currency={currency}
        presetBalances={presetBalances}
        customAmountAllowed={customAmountAllowed}
        locale={locale}
        onChange={onChange}
        errorText={errors.getError('amount') && errors.getError('amount')}
      />
    </StyleableSection>
  );

}

export default withStyles(styles)(AmountSection);
